import { createSlice } from '@reduxjs/toolkit';
import set from 'lodash/set';
import toPath from 'lodash/toPath';
import { CONSTANTS } from '../../../Helpers/Configuration';
const settingsSlice = createSlice({
    name: 'settings',
    initialState: {
        autosave: {
            status: CONSTANTS.autosaveStatuses.INITIAL,
        },
        forceShowErrors: {},
        externalMode: false,
        hiddenPageIds: [],
        previewMode: false,
        inquiryMode: false,
        importAdminMode: false,
        revision: 0,
        supplementalFormMode: false,
        showMobileSidebarDialog: false,
        supplementalDocumentsHasChanges: false
    },
    reducers: {
        setSettingsValue: (state, action) => {
            set(state, toPath(action.payload.name), action.payload.value);
            return state;
        },
    },
});
export const {
    checkForceShowErrors,
    clearForceShowErrors,
    setForceShowErrors,
    setSettingsValue,
} = settingsSlice.actions;
export default settingsSlice.reducer;
